import React from 'react'
import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import SyncRequestRow from './SyncRequestRow'
import { Table } from 'Components/Table'
import ErrorMessage from './ErrorMessage'
import SubmitButton from 'Components/Form/SubmitButton'

const SyncModal = ({ onClose, syncRequests, errorMessage }) => {
  return (
    <Modal show={true} onHide={onClose}>
      <ModalHeader closeButton>
        <ModalTitle>Sync Operations</ModalTitle>
      </ModalHeader>
      <ModalBody>{renderContent(errorMessage, syncRequests)}</ModalBody>
      <ModalFooter>
        <SubmitButton value="Okay" onClick={onClose} />
      </ModalFooter>
    </Modal>
  )
}

const renderContent = function(errorMsg, syncRequests) {
  if (errorMsg) return <ErrorMessage>{errorMsg}</ErrorMessage>
  return (
    <Table>
      <tbody>
        {syncRequests.map(r => (
          <SyncRequestRow {...r} />
        ))}
      </tbody>
    </Table>
  )
}

export default SyncModal



// WEBPACK FOOTER //
// ./src/Components/Sync/Modal.js